import { render, staticRenderFns } from "./PesanKapusdokkes.vue?vue&type=template&id=15f67333&scoped=true"
import script from "./PesanKapusdokkes.vue?vue&type=script&lang=js"
export * from "./PesanKapusdokkes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f67333",
  null
  
)

export default component.exports